export default {
    name: 'MailingType',
    props: ['uuid', 'accountDraftData', 'status', 'uuid_intervener', 'mailing_type_intervener'],

    data() {
        return {
            mailing_type: '',
            isLoading: false
        };
    },

    mounted() {
        this.mailing_type = this.mailing_type_intervener;
    },
    computed: {
        displayedMailingType() {
            return this.mailing_type;
        }
    }
};
